var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.faqs.length > 0
    ? _c(
        "section",
        { staticClass: "faq-section" },
        [
          _c(
            "accordion-group",
            _vm._l(_vm.faqs, function(faq) {
              return _c(
                "accordion",
                { key: faq.id, attrs: { heading: faq.question } },
                [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.bodyText(faq.answer)) }
                  })
                ]
              )
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }